<template>
  <div>
    <el-table class="trade-pair-table" :data="tradePairList">
      <el-table-column label="时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="amountPrecision" label="操作人ID">
        <template slot-scope="scope">{{ scope.row.userId }}</template>
      </el-table-column>
      <el-table-column prop="status" label="推送人群">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 3">全部</span>
          <span v-else-if="scope.row.status == 2">部分</span>
          <span v-else>单人</span>
        </template>
      </el-table-column>
      <el-table-column prop="pushPlatform" label="推送平台"></el-table-column>
      <el-table-column prop="pushContent" label="推送内容"></el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handlePageChanged"
    ></pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'pushList',
  components: {
    Pagination
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('pushsetting', ['pagination', 'totalCount', 'tradePairList'])
  },
  methods: {
    handlePageChanged(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped></style>
